import { signOut } from "@aws-amplify/auth";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./NavigationSidebar.css";
import Logo from "../Navigationsidebar/generic-logo-for-demo-02.jpg";

const NavigationSidebar = ({ className, isOpen }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(); // Use signOut directly
      navigate("/"); // Redirect to login page after logout
    } catch (error) {
      console.error("Error signing out: ", error);
    }
  };

  const pages = [
    { path: "/D01_Demographics", label: "Survey Demographics" },
    { path: "/D02_Overall_Engagement", label: "Overall Engagement" },
    { path: "/D03_Engagement_Summary", label: "Engagement Summary" },
    {
      path: "/D04_Responses_by_Demographic_Category",
      label: "Responses by Demographic Category",
    },
    { path: "/D05_Response_Distribution", label: "Response Distribution" },
    {
      path: "/D06_Detailed_Scores_by_Demographic_Category",
      label: "Detailed Scores by Demographic Category",
    },
    { path: "/D07_Range_of_Responses", label: "Range of Responses" },
    {
      path: "/D08_Self_Reported_Engagement",
      label: "Self Reported Engagement",
    },
    {
      path: "/D09_Engagement_Questions_Sorted",
      label: "Engagement Questions Sorted",
    },
    { path: "/D10_Open_Text_Responses", label: "Open Text Responses" },
    { path: "/D11_Open_Text_Heatmap", label: "Open Text Heat Map" },
    {
      path: "/D12_Engagement_Areas_by_Impact",
      label: "Engagement Areas by Impact",
    },
    // {
    //   path: "/D13_Survey_Specific_Questions",
    //   label: "Survey Specific Questions",
    // },
    // { path: "/D14_Year_over_Year_by_Area", label: "Year Over Year by Area" },
    // {
    //   path: "/D15_Year_over_Year_by_Question",
    //   label: "Year Over Year by Question",
    // },
    // {
    //   path: "/D16_Year_over_Year_Self_Reported",
    //   label: "Year Over Year Self Reported",
    // },
    { path: "/D17_Open_Text_Top_Themes", label: "Open Text Top Themes" },
    // { path: "/generatereport", label: "Generate Report" },
  ];

  return (
    <div
      className={`navigation-sidebar ${
        isOpen ? "navigation-sidebar-open" : "navigation-sidebar-closed"
      }`}
    >
      <div className="navigation-sidebar-header">
        <img src={Logo} alt="Logo" className="navigation-sidebar-logo" />
      </div>
      <ul className="navigation-sidebar-menu">
        {pages.map((page) => (
          <li key={page.path} onClick={() => navigate(page.path)}>
            {page.label}
          </li>
        ))}
        {/* Logout option */}
        <li className="navigation-sidebar-logout" onClick={handleLogout}>
          Logout
        </li>
      </ul>
    </div>
  );
};

export default NavigationSidebar;
